module.exports = __webpack_public_path__ + "static/media/logo.d1ea6af9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = 3235
// module chunks = 0